export var DataAnalytics;
(function (DataAnalytics) {
    DataAnalytics["clickTrackingEvent"] = "clicktrackingevent";
})(DataAnalytics || (DataAnalytics = {}));
export var DataObject;
(function (DataObject) {
    DataObject["button"] = "button";
    DataObject["collapse"] = "collapse";
    DataObject["dropdownExpand"] = "drop-down-expand";
    DataObject["dropdownCollapse"] = "drop-down-collapse";
    DataObject["expand"] = "expand";
    DataObject["link"] = "link";
})(DataObject || (DataObject = {}));
//# sourceMappingURL=common.js.map